import { quizService } from './quiz.service';
export async function checkQuizVisibility({ quizId, userId }) {
    const quizStatus = await quizService.getStatus({ userId, id: quizId }, { useCache: true });
    const visible = quizStatus === 'not seen';
    return visible;
}
//# sourceMappingURL=check-quiz-visibility.js.map